<template>
<div>
    <!-- Loading State -->
    <div v-if="loading" class="d-flex align-center py-3">
        <v-progress-circular indeterminate color="primary" size="24"></v-progress-circular>
        <span class="ml-2 grey--text">Loading billing settings...</span>
    </div>

    <!-- Settings Form -->
    <div v-else-if="organization_settings_rate_card">
        <div class="mb-4">
            <m-edit-emails
                label="Invoice Email Recipients"
                v-model="organization_settings_rate_card.send_invoice_to_customer_emails"
                @input="patch"
                hint="Enter email addresses that should receive invoices"
                persistent-hint
            />
            <div class="d-flex align-center mt-2">
                <v-icon small color="grey lighten-1" class="mr-2">mdi-information-outline</v-icon>
                <span class="caption grey--text text--darken-1">Invoices will be sent to these email addresses when they are generated</span>
            </div>
        </div>
    </div>

    <!-- Error State -->
    <div v-else class="my-4">
        <v-alert
            type="warning"
            outlined
            dense
        >
            Unable to load billing settings. Please try refreshing the page.
        </v-alert>
    </div>
</div>
</template>

<script>
const _ = require('lodash');
export default {

    props: {
        organization_id: {
            type: String,
            default: function() { return null; }
        },
    },

    data() {
        return {
            organization_settings_rate_card: null,
            loading: true,
            error: null
        }
    },

    mounted () {
        this.getProfile();
    },

    methods: {
        getProfile() {
            this.loading = true;
            this.error = null;

            this.$rc.rest({
                'spinner': false,
                'endpoint': 'GET: /api/v1/billing/organization/rate-card-profile/:organization_id',

                'params' : {
                        'organization_id': this.organization_id,
                    },

                'on_success': (data) => {
                        this.organization_settings_rate_card = data.organization_settings_rate_card;
                        this.loading = false;
                    },

                'on_error': (error) => {
                        this.error = error;
                        this.loading = false;
                        this.$rc.alert('Error', 'Unable to get billing profile: ' + error);
                    },
            });
        },

        patch: _.debounce(function(){
            this.doPatch();
        }, 751),

        doPatch() {
            if (!this.organization_settings_rate_card) return;

            this.$rc.rest({
                'spinner': false,
                'endpoint': 'PATCH: /api/v1/billing/organization/org-controlled-billing-settings',

                'params' : {
                        'organization_id': this.organization_id,
                        'send_invoice_to_customer_emails': this.organization_settings_rate_card.send_invoice_to_customer_emails,
                    },

                'on_success': () => {
                    },

                'on_error': (error) => {
                        this.$rc.alert('Error', 'Unable to save billing settings: ' + error);
                    },
            });
        },
    },
}
</script>

<style lang="scss" scoped>

</style>